/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragmentDoc } from './SettingsPageLineActivationUserVariableDefinitionValueSelectOptionForm.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type UpdateUserVariableDefinitionInput = {
  guid: string | number;
  name: string;
};

export type SettingsPageLineActivationUserVariableEditFormUserVariableDefinitionFragment = { guid: string, name: string, value:
    | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueString', void: any }
    | { __typename: 'UserVariableDefinitionValueText', void: any }
   };

export type UpdateUserVariableDefinitionMutationVariables = Exact<{
  input: Types.UpdateUserVariableDefinitionInput;
}>;


export type UpdateUserVariableDefinitionMutation = { updateUserVariableDefinition: { void: any } };

export const SettingsPageLineActivationUserVariableEditFormUserVariableDefinitionFragmentDoc = gql`
    fragment SettingsPageLineActivationUserVariableEditFormUserVariableDefinition on UserVariableDefinition {
  guid
  name
  value {
    __typename
    ... on UserVariableDefinitionValueString {
      void
    }
    ... on UserVariableDefinitionValueText {
      void
    }
    ... on UserVariableDefinitionValueSelect {
      options {
        ...SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOption
      }
    }
    ... on UserVariableDefinitionValueMultipleSelect {
      options {
        ...SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOption
      }
    }
  }
}
    ${SettingsPageLineActivationUserVariableDefinitionValueSelectOptionFormOptionFragmentDoc}`;
export const UpdateUserVariableDefinitionDocument = gql`
    mutation UpdateUserVariableDefinition($input: UpdateUserVariableDefinitionInput!) {
  updateUserVariableDefinition(input: $input) {
    void
  }
}
    `;

/**
 * __useUpdateUserVariableDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateUserVariableDefinitionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserVariableDefinitionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateUserVariableDefinitionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserVariableDefinitionMutation(options: VueApolloComposable.UseMutationOptions<UpdateUserVariableDefinitionMutation, UpdateUserVariableDefinitionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateUserVariableDefinitionMutation, UpdateUserVariableDefinitionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateUserVariableDefinitionMutation, UpdateUserVariableDefinitionMutationVariables>(UpdateUserVariableDefinitionDocument, options);
}
export type UpdateUserVariableDefinitionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateUserVariableDefinitionMutation, UpdateUserVariableDefinitionMutationVariables>;